import { useEffect } from 'react';
import {
  Reasoning,
  ReasoningTrigger,
} from '@/components/ai-elements/reasoning';
import { markChatThinkingVisible } from '../chat-ux-metrics';

type StreamingIndicatorProps = {
  /** Début de tour — partagé avec le Reasoning du MessageBubble. */
  startedAt?: number;
};

/**
 * Feedback immédiat post-submit : le Reasoning AI Elements (shimmer
 * « Réflexion en cours ») remplace le spinner générique. `defaultOpen={false}`
 * évite d'ouvrir un panneau vide avant l'arrivée des parts reasoning.
 */
export function StreamingIndicator({ startedAt }: StreamingIndicatorProps) {
  useEffect(() => {
    markChatThinkingVisible();
  }, []);

  return (
    <div
      aria-live="polite"
      className="group/message w-full"
      data-role="assistant"
      data-testid="message-assistant-loading"
      role="status"
    >
      <Reasoning
        className="mb-0 w-full"
        defaultOpen={false}
        isStreaming
        startedAt={startedAt}
      >
        <ReasoningTrigger />
      </Reasoning>
    </div>
  );
}
